// extracted by mini-css-extract-plugin
export default {"status":"Button_status__yFwW6","isSelected":"Button_isSelected__PXU9-","dark":"Button_dark__LA9E9"};